import { render, staticRenderFns } from "./EloadTransactionDetails.vue?vue&type=template&id=7378875c"
import script from "./EloadTransactionDetails.vue?vue&type=script&lang=js"
export * from "./EloadTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./EloadTransactionDetails.vue?vue&type=style&index=0&id=7378875c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports